const SellingTipsPage = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Nasveti za hitro prodajo</h1>
      
      <p>
        Želite svoj izdelek čim hitreje prodati? Upoštevajte spodnje nasvete in povečajte možnosti za uspešno prodajo na Bazarc!
      </p>

      <h3 className="mt-4 mb-3">1. Kvalitetne fotografije</h3>
      <p>
        Prvi vtis je najpomembnejši! Poskrbite, da so slike izdelka jasne, svetle in prikazujejo izdelek iz različnih kotov. Uporabite nevtralno ozadje in naravno svetlobo.
      </p>

      <h3 className="mt-4 mb-3">2. Iskren in natančen opis</h3>
      <p>
        Opišite izdelek čim bolj podrobno. Navedite morebitne pomanjkljivosti ali obrabo, da se izognete neprijetnostim ob prodaji. Kupci cenijo transparentnost.
      </p>

      <h3 className="mt-4 mb-3">3. Prava cena</h3>
      <p>
        Ocenite realno vrednost izdelka. Preglejte podobne oglase na platformi in nastavite konkurenčno ceno. Previsoka cena lahko odvrne kupce.
      </p>

      <h3 className="mt-4 mb-3">4. Prava kategorija in oznake</h3>
      <p>
        Uvrstite izdelek v ustrezno kategorijo in uporabite primeren naziv, da ga kupci lažje najdejo pri iskanju.
      </p>

      <h3 className="mt-4 mb-3">5. Hitra odzivnost</h3>
      <p>
        Redno spremljajte sporočila in se hitro odzivajte na vprašanja kupcev. Hitra komunikacija povečuje zaupanje in verjetnost prodaje.
      </p>

      <h3 className="mt-4 mb-3">6. Posodabljanje oglasa</h3>
      <p>
        Če izdelek po nekaj dneh še ni prodan, razmislite o osvežitvi opisa, novih fotografijah ali prilagoditvi cene. Oglas lahko poskusite deliti tudi na družbenih omrežjih, da dosežete širše občinstvo.
      </p>
    </div>
  );
};

export default SellingTipsPage;